"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PHONE_MAX_WIDTH_PX = exports.MEDIA_TABLET_UP = exports.MEDIA_PHONE = exports.MEDIA_DESKTOP_UP = exports.DESKTOP_MIN_WIDTH_PX = void 0;
/**
 * The responsive breakpoints every product's web app lays out by.
 *
 * Mobile-first: components author their base styles for phones and layer
 * desktop enhancements at these breakpoints. StyleX cannot read JS
 * constants inside `@media` keys, so `stylex.create(...)` styles must use the
 * literal media strings below verbatim — keep them identical to these
 * constants so there is a single source of truth for the cutoffs.
 *
 *   phone   : width <= 640px
 *   tablet  : 641px .. 1024px
 *   desktop : width >= 1025px
 */ // Raw pixel cutoffs, exported for any JS-level decision (e.g. matchMedia).
const PHONE_MAX_WIDTH_PX = exports.PHONE_MAX_WIDTH_PX = 640;
const DESKTOP_MIN_WIDTH_PX = exports.DESKTOP_MIN_WIDTH_PX = 1025; // Canonical media-query strings. Mirror these literally in StyleX styles.
const MEDIA_PHONE = exports.MEDIA_PHONE = "@media (max-width: 640px)";
const MEDIA_TABLET_UP = exports.MEDIA_TABLET_UP = "@media (min-width: 641px)";
const MEDIA_DESKTOP_UP = exports.MEDIA_DESKTOP_UP = "@media (min-width: 1025px)";